import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertTransferClothstk = createAsyncThunk('insertTransferClothstk', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertTransferClothstk`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

// export const updateReadyMStkEntry = createAsyncThunk('updateReadyMStkEntry', async (postData) => {
//     try {
//         const response = await axios.post(`${baseUrl}?apicall=updateReadyMadeStk`, postData);
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// });

export const fetchTransferClothReg = createAsyncThunk('fetchTransferClothReg', async (id) => {
    try {
         const endpoint = id ? `getTransferClothstk_data&trId=${id}` : 'getTransferClothstk_data';
        const response = await axios.get(`${baseUrl}?apicall=getTransferClothstk_data`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchTransferClothslist = createAsyncThunk('fetchTransferClothslist', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getTransferCloths_list`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


// export const deleteSingleReadyMStk = createAsyncThunk('deleteSingleReadyMStk', async (id) => {
//     try {
//         const response = await axios.delete(`${baseUrl}?apicall=deleteReadyMadeStk&readyId=${id}`);
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// });


const TransferClothSlice = createSlice({
    name: 'TransferData',
    initialState: {
        isLoading: false,
        transData: null,
        clothlist: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTransferClothReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTransferClothReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.transData = action.payload;
        });
        builder.addCase(fetchTransferClothReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchTransferClothslist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTransferClothslist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clothlist = action.payload;
        });
        builder.addCase(fetchTransferClothslist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default TransferClothSlice.reducer;
